<cc-gaming-stories-container *ngIf="isLoadingGamingStories"></cc-gaming-stories-container>
